import FolderOverview from 'scoreboard/components/folder-overview'

var DatasetsFolderOverview = FolderOverview.extend({

	getIcon: function(child) {
		let iconByType = {
			'dataset': 'dataset',
			'view' : 'dataset-view'
		}
		return iconByType[child.type]
	},

	folderContainsKey: function() {
		if (this.model.get('rootDatasetId')) {
			return 'datasets.views'
		} else {
			return 'datasets.datasets'
		}
	},

	allowEdit: function() {
		return this.model.isEditable()
	}

})

export default DatasetsFolderOverview

DatasetsFolderOverview.__filename__ = 'datasets/overview/datasets-folder-overview.js'
